import { h, ListView } from "harmaja"
import * as L from "lonna"
import { Reaction } from "../../../common/src/domain"

export const REACTION_EMOJIS = ["👍", "❤️", "🎉", "😂", "🤔", "👀"]
const LIFETIME_MS = 2000

type ShownReaction = Reaction & { key: number }

// Floating emoji that appear at a board position and fade out. Purely ephemeral.
export const ReactionsView = ({ reactions }: { reactions: L.EventStream<Reaction> }) => {
    const shown = L.atom<ShownReaction[]>([])
    let counter = 0
    reactions.forEach((r) => {
        const key = counter++
        shown.modify((s) => [...s, { ...r, key }])
        setTimeout(() => shown.modify((s) => s.filter((x) => x.key !== key)), LIFETIME_MS)
    })
    return (
        <ListView<ShownReaction, number>
            observable={shown}
            renderItem={(r) => (
                <span className="reaction" style={{ left: r.position.x + "em", top: r.position.y + "em" }}>
                    {r.emoji}
                </span>
            )}
            getKey={(r) => r.key}
        />
    )
}
